import React from 'react';
import { Tag, ChevronRight } from 'lucide-react';

interface TagItem {
  id: string;
  name: string;
  count: number;
  percentage: number;
  color: string;
}

interface TopTagsProps {
  tags: TagItem[];
}

const TopTags: React.FC<TopTagsProps> = ({ tags }) => {
  return (
    <div className="bg-[#0F1629] rounded-xl p-6 relative overflow-hidden group">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      <div className="relative">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <Tag className="h-5 w-5 text-purple-500" />
            <h2 className="text-lg font-semibold text-white">Top Tags</h2>
          </div>
        </div>

        {/* Tags List */}
        <div className="space-y-4">
          {tags.map((tag) => (
            <div
              key={tag.id}
              className="group/tag bg-gray-800/20 rounded-lg p-4 hover:bg-gray-800/30 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className={`p-2 rounded-lg bg-gray-800/30 ${tag.color}`}>
                    <Tag className="h-4 w-4" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-300">
                      {tag.name}
                    </div>
                    <div className="text-xs text-gray-500">
                      {tag.count} assets
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="text-sm font-medium text-gray-400">
                    {tag.percentage}%
                  </div>
                  <ChevronRight className="h-4 w-4 text-gray-500 opacity-0 group-hover/tag:opacity-100 transition-opacity" />
                </div>
              </div>
              <div className="mt-3">
                <div className="h-1 bg-gray-800 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full ${tag.color} transition-all duration-500`}
                    style={{ width: `${tag.percentage}%` }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopTags;